import { Link } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'

export function DashboardPage() {
  const { user } = useAuth()

  return (
    <main className="page">
      <h1>Välkommen{user ? `, ${user.email}` : ''}</h1>
      <p>
        Anslut dina plattformskonton, ladda upp en film och låt Claude skriva
        texten. Ingenting publiceras utan att du godkänner det först.
      </p>

      <section className="card">
        <h2>Kom igång</h2>
        <ol className="phase-list">
          <li>
            <Link to="/settings/social-accounts">Anslut dina konton</Link>
            {' — YouTube, Facebook och Instagram (Meta ger båda i en anslutning).'}
          </li>
          <li>
            {user && user.passkeyCount === 0 ? (
              <>
                <Link to="/settings/security">Registrera en passkey</Link>
                {' — snabbare inloggning nästa gång.'}
              </>
            ) : (
              'Passkey registrerad ✓'
            )}
          </li>
          <li>
            <Link to="/content">Skapa innehåll från en idé</Link>
            {' — ett utkast per publiceringsyta, som du redigerar innan publicering.'}
          </li>
        </ol>
      </section>
    </main>
  )
}
